import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ChevronUp, ChevronDown } from "lucide-react";
import { MarginAnalysisState, MarginAnalysisActions } from './useMarginAnalysis';
import { formatCurrency } from './utils';
interface LeaderboardTableProps {
  state: MarginAnalysisState;
  actions: MarginAnalysisActions;
}
const LeaderboardTable: React.FC<LeaderboardTableProps> = ({
  state,
  actions
}) => {
  const {
    leaderboardData,
    isTableExpanded,
    filterType
  } = state;
  const {
    setIsTableExpanded
  } = actions;
  return <Card className="bg-gradient-to-br from-[#1e293b] to-[#111827] border-primary/20 shadow-md hover:shadow-[#6366F1]/10 transition-all duration-300 rounded-md flex-1 my-[11px]">
      <CardContent className="p-4 flex flex-col h-full py-0 my-[9px]">
        <Collapsible open={isTableExpanded} onOpenChange={setIsTableExpanded}>
          <CollapsibleTrigger className="w-full flex justify-between items-center cursor-pointer">
            <h3 className="text-[#D6BCFA] text-[15px] font-semibold mb-2">Gross Margin Performance</h3>
            <div className="flex items-center text-xs text-primary-light">
              <span className="mr-1">Click to {isTableExpanded ? 'collapse' : 'expand'}</span>
              {isTableExpanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
            </div>
          </CollapsibleTrigger>
          <CollapsibleContent>
            <ScrollArea className="h-[200px] w-full mt-2 text-white font-semibold text-left text-[10px]">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead className="text-[10px] text-primary">Region</TableHead>
                    <TableHead className="text-[10px] text-primary">Country</TableHead>
                    <TableHead className="text-[10px] text-primary">Account</TableHead>
                    <TableHead className="text-[10px] text-primary">Name</TableHead>
                    {filterType === "product" && <TableHead className="text-[10px] text-primary">Product</TableHead>}
                    {filterType === "industry" && <TableHead className="text-[10px]">Industry</TableHead>}
                    <TableHead className="text-[10px] text-primary">Revenue</TableHead>
                    <TableHead className="text-[10px] text-primary">Cost</TableHead>
                    <TableHead className="text-[10px] text-primary">Gross Profit</TableHead>
                    <TableHead className="text-[10px] text-primary">Margin %</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {leaderboardData.map((item, index) => {
                  const itemRevenue = item.achievement || 0;
                  const itemCost = item.cogs || 0;
                  const grossProfit = itemRevenue - itemCost;
                  const margin = itemRevenue > 0 ? grossProfit / itemRevenue * 100 : 0;
                  return <TableRow key={index}>
                        <TableCell className="text-[10px]">{item.region}</TableCell>
                        <TableCell className="text-[10px]">{item.country}</TableCell>
                        <TableCell className="text-[10px]">{item.account_name}</TableCell>
                        <TableCell className="text-[10px]">{item.name || '-'}</TableCell>
                        {filterType === "product" && <TableCell className="text-[10px]">{item.product_line}</TableCell>}
                        {filterType === "industry" && <TableCell className="text-[10px]">{item.industry}</TableCell>}
                        <TableCell className="text-[10px]">{formatCurrency(itemRevenue)}</TableCell>
                        <TableCell className="text-[10px]">{formatCurrency(itemCost)}</TableCell>
                        <TableCell className="text-[10px]">{formatCurrency(grossProfit)}</TableCell>
                        <TableCell className="text-[10px]">{margin.toFixed(1)}%</TableCell>
                      </TableRow>;
                })}
                </TableBody>
              </Table>
            </ScrollArea>
          </CollapsibleContent>
        </Collapsible>
      </CardContent>
    </Card>;
};
export default LeaderboardTable;